<template>
    <JobComponent />
</template>


<script>
import JobComponent from '@/components/job/JobComponent.vue';


export default {
    name: 'JobView',
    components: {
        JobComponent
    }
}
</script>